/* oxlint-disable typescript/no-explicit-any */
export function promiseWithResolvers<T>() {
  let resolver: ((value: T | PromiseLike<T>) => void) | null = null;
  let rejecter: ((reason?: any) => void) | null = null;

  const promise = new Promise<T>((resolve, reject) => {
    resolver = resolve;
    rejecter = reject;
  });

  return {
    promise,
    resolve: (value: T | PromiseLike<T>) => resolver?.(value),
    reject: (reason?: any) => rejecter?.(reason),
  };
}

export type PromiseContainer<T> = {
  resolve: (value: T | PromiseLike<T>) => void;
  reject: (reason?: any) => void;
};
